import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
import ScrollToTop from './ScrollToTop';


const Root = () => {
    return (
        <div>
             <ScrollToTop /> {/* This ensures scrolling to the top on every route change */}

            <Outlet></Outlet>
            {/* <Footer></Footer> */}

        </div>
    )
}

export default Root